var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDistinctCountNoBlanks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07 15.625V.375",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.555 11.869l-.09.414h-1.02l-.246 1.172h1.098l-.106.414h-1.074l-.344 1.55h-.492l.336-1.55h-.976l-.329 1.55h-.488l.328-1.55H11.13l.078-.414h1.035l.238-1.172h-1.082l.082-.414h1.082l.329-1.57h.492l-.328 1.57h.984l.336-1.57h.48l-.328 1.57h1.028zm-1.594.414h-.984l-.258 1.172h.992l.25-1.172zm1.594-10.214l-.09.414h-1.02L14.2 3.655h1.098l-.106.414h-1.074l-.344 1.55h-.492l.336-1.55h-.976l-.329 1.55h-.488l.328-1.55H11.13l.078-.414h1.035l.238-1.172h-1.082l.082-.414h1.082l.329-1.57h.492l-.328 1.57h.984l.336-1.57h.48l-.328 1.57h1.028zm-1.594.414h-.984l-.258 1.172h.992l.25-1.172zM4.88 6.47l-.09.414H3.77l-.246 1.172H4.62l-.105.414H3.442l-.344 1.55h-.492l.336-1.55h-.977l-.328 1.55h-.488l.328-1.55H.453l.078-.414h1.036l.238-1.172H.723l.082-.414h1.082l.328-1.57h.492L2.38 6.47h.985L3.7 4.9h.48l-.327 1.57H4.88zm-1.595.414h-.984l-.258 1.172h.992l.25-1.172z",
    fill: "currentColor"
  })));
}

export default SvgCustomDistinctCountNoBlanks;